import formset from './formset.js';

const REGEX = /(.+)-(\d+)/;

const flatten = function(record, property)
{
	let copy = {...record};
	let is_array = Array.isArray(copy[property]);
	(is_array ? copy[property] : [copy[property]]).forEach((entry, index) =>
	{
		Object.keys(entry || {}).forEach(key => 
		{
			let new_key = is_array ? `${key}-${index}` : `${property}_${key}`;
			copy[new_key] = entry[key];
		});
	});
	delete copy[property];
	return copy;
};

const deepen = function(record, property)
{
	let copy = {...record};
	Object.keys(copy).forEach(key =>
	{
		let match = key.match(REGEX);
		if (match)
		{
			let index = Number(match[2]);
			if (!copy[property])
				copy[property] = [];
			if (!copy[property][index])
				copy[property][index] = {};
			copy[property][index][match[1]] = copy[key];
			delete copy[key];
		}
	});
	if (copy[property])
		copy[property] = copy[property].filter(entry => entry);
	return copy;
};

const getTopIndex = function(record)
{
	let index = -1;
	Object.keys(record || {}).forEach(key =>
	{
		let match = key.match(REGEX);
		if (match?.[2] > index)
			index = Number(match[2]);
	});
	return index;
};

/* 
 * Recebe um array de registros e monta um array de <option> com base em uma 
 * propriedade para o valor e uma ou mais propriedades para os rótulos da opção:
 *
 * <option value="array[value]">array[label]</option>
 *
 * Opcionalmente pode indicar que uma das opções receba o atributo "selected".
 *
 * Também permite que o rótulo seja uma combinação de mais de uma propriedade,
 * como CNPJ + Nome, por exemplo. Também pode indicar rótulos alternativos:
 * caso algum deles esteja undefined, o(s) seguinte(s) será(ão) adotado(s).
 *
 * No caso de uma dessas propriedades ser um array (SKU do produto), esse array
 * será concatenado antes de ser incluído como rótulo da opção. O separador dos
 * elementos do array também poderá ser especificado (default é '').
 *
 * Se add_empty = true, um <option> vazio com valor -1 será incluído no início
 * da lista.
 */
const makeOptions = function(array, value, labels, separator = '', selected = -1, add_empty = false)
{

	const is_selected = function(index)
	{
		return index == selected ? ' selected' : '';
	}

	const format = function(value)
	{
		return Array.isArray(value) ? value.join(separator) : value;
	}

	let options = array.map((entry, index) => 
		`<option value="${entry[value]}"${is_selected(index)}>${labels.map(label => format(entry[label])).join(' ').trim()}</option>`
	).join('\n');

	return (add_empty ? '<option value="-1"></option>' : '') + options;

};

const record = {

	edit(descriptor, callback, current_data, autorow = true)	// { html: '', form: {}, fields: [] } (formset)
	{
		let fs = formset.create(descriptor, async (updated_data) =>
		{
			if (!callback || await callback(updated_data, current_data))
				fs.destroy();
		});
		fs.init = (() =>
		{
			fs.form.eraseValues();						// Must come before init()
			Object.getPrototypeOf(fs).init.call(fs, autorow);
			let extra_row = autorow ? 1 : 0;
			if (fs.hasTables())
			{
				fs.setTableHeight(fs.getTableSize());
				fs.appendRows(Math.max(getTopIndex(current_data), (fs.getTableSize() - 1) - extra_row) + extra_row);
			}
			if (current_data)
			{
				fs.form.setValues(current_data);
				fs.form.refresh();
				// Dispara 'change' só em company_id para carregar opções (Programa, Categoria, Classes, etc.) sem passar valores inválidos a outros observers
				const company_id = current_data.company_id;
				if (company_id != null && company_id !== '')
				{
					const field = fs.form.getFieldBySelector('#company_id');
					if (field && typeof field.publish === 'function')
						field.publish('change', field, company_id);
					// Refresh da form após opções (Programa, Categoria, etc.) carregarem para exibir labels em vez de vazio
					setTimeout(() => fs.form.refresh(), 150);
				}
				// Dispara 'change' nos campos UF para carregar lista de municípios (obs_load_options cities)
				['billing_address_state', 'delivery_address_state', 'address_state'].forEach(name =>
				{
					const val = current_data[name];
					if (val != null && val !== '')
					{
						const field = fs.form.getFieldBySelector(`#${name}`);
						if (field && typeof field.publish === 'function')
							field.publish('change', field, val);
					}
				});
				setTimeout(() =>
				{
					fs.form.refresh();
					if (descriptor.form && typeof descriptor.form.afterEditSetValues === 'function')
						descriptor.form.afterEditSetValues(fs);
				}, 300);
			}
			else
				fs.form.refresh();
		})();
		return fs;
	}

};

export { record as default, flatten, deepen, getTopIndex, makeOptions };

